import React from "react";
import {
  Box,
  Menu,
  FormControlLabel,
  styled,
  Divider,
  Button,
  Checkbox,
} from "@mui/material";
import { IWithClassName } from "../../theme/default.theme";
import { ReportGroup } from "../../enum/report";

interface IProps extends IWithClassName {
  anchorEl: HTMLElement | null;
  setAnchorEl: (value: HTMLElement | null) => void;
  groupByHandler: (value: ReportGroup, checked: boolean) => void;
  searchReport: () => void;
  groupBy: string;
}
const FilterMenu = ({ anchorEl, setAnchorEl, className, groupByHandler, searchReport, groupBy }: IProps) => (
  <Menu
    anchorEl={anchorEl}
    open={!!anchorEl}
    onClose={() => setAnchorEl(null)}
    className={className}
  >
    <Box className="table-view-filter-cont">
        <Box className="table-view-filter">
            <FormControlLabel
              value="Campaign Name"
              control={
                <Checkbox onChange={({target}) => groupByHandler(ReportGroup.CampaignName, target.checked)} checked={groupBy.includes(ReportGroup.CampaignName)}/>
              }
              label="Campaign Name"
            />
            <FormControlLabel
              value="Status"
              control={
                <Checkbox onChange={({target}) => groupByHandler(ReportGroup.Status, target.checked)} checked={groupBy.includes(ReportGroup.Status)}/>
              }
              label="Status"
            />
        </Box>
        <Box className="table-view-filter">
          <FormControlLabel
            value="App Names (Placement)"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.AppName, target.checked)} checked={groupBy.includes(ReportGroup.AppName)}/>
            }
            label="App Names (Placement)"
          />
          <FormControlLabel
            value="Event Name (Goal Name)"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.GoalName, target.checked)} checked={groupBy.includes(ReportGroup.GoalName)}/>
            }
            label="Event Name (Goal Name)"
          />
        </Box>
        <Box className="table-view-filter">
          <FormControlLabel
            value="Country"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.Country, target.checked)} checked={groupBy.includes(ReportGroup.Country)}/>
            }
            label="Country"
          />
          <FormControlLabel
            value="City"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.City, target.checked)} checked={groupBy.includes(ReportGroup.City)}/>
            }
            label="City"
          />
          <FormControlLabel
            value="OS"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.OS, target.checked)} checked={groupBy.includes(ReportGroup.OS)}/>
            }
            label="OS"
          />
        </Box>
        <Box className="table-view-filter">
          <FormControlLabel
            value="Month"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.Month, target.checked)} checked={groupBy.includes(ReportGroup.Month)}/>
            }
            label="Month"
          />
          <FormControlLabel
            value="Date"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.Date, target.checked)} checked={groupBy.includes(ReportGroup.Date)}/>
            }
            label="Date"
          />
          <FormControlLabel
            value="Hour"
            control={
              <Checkbox onChange={({target}) => groupByHandler(ReportGroup.Hour, target.checked)} checked={groupBy.includes(ReportGroup.Hour)}/>
            }
            label="Hour"
          />
      </Box>
    </Box>
    <Divider />
    <Box className="table-view-filter-action">
      <Button
        variant="contained"
        color="primary"
        onClick={searchReport}
      >
        Apply
      </Button>
    </Box>
  </Menu>
);

export default styled(FilterMenu)(({ theme }) => ({
  ".MuiPaper-root": {
    width: "50%",
    minWidth: 600,
    backgroundColor: theme.palette.grey[100],
  },
  ".table-view-filter-cont": {
    display: "flex",
    justifyContent: "space-around",
  },
  ".table-view-filter": {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },
  ".MuiFormControlLabel-root": {
    margin: theme.spacing(0, 1),
    border: 0,
  },
  ".MuiFormControlLabel-root:has(span.Mui-checked)": {
    border: 0,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey[100],
  },
  ".MuiButtonBase-root-MuiRadio-root.Mui-checked": {
    color: theme.palette.text.primary,
  },
  ".table-view-filter-action": {
    display: "flex",
    justifyContent: "right",
    ".MuiButton-contained": {
      margin: theme.spacing(1),
      width: 100,
    },
  },
}));
